// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdatePOApprovalRuleMutation($input: UpdatePOApprovalRuleInput!) {
    updatePOApprovalRule(input: $input) {
      poApprovalRuleEdge {
        node {
          id
          minAmount
          maxAmount
          approver {
            id
            firstName
            lastName
            email
          }
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
